import React, { Component } from "react";
import { toJS } from "mobx";
import { observer, inject } from "mobx-react";
import PropTypes from "prop-types";
import { Loader, Toastr, Utils } from "arv-reactcomponents";
import OrderConfirmStaticDetails from "../../component/OrderConfirmComponents/OrderConfirmStaticDetails";
import OrderSummaryBlock from "../../component/OrderConfirmComponents/OrderSummaryBlock";
import OrderConsignmentsBlock from "../../component/OrderConfirmComponents/OrderConsignmentsBlock";
import {
  setPageType,
  readCookie,
  isAuthenticated,
  removePromoCode,
} from "../../utils";
import {
  pageType,
  Checkout,
  SEPHORA_BRANDS,
  Loyalty,
} from "npmlinks-constants";
import Analytics from "../../analytics";
import Event from "../../analytics/eventFactory";
import GTM from "../../analytics/GTM";

@inject("OrderConfirmationStore", "CheckoutStore", "AddressStore")
@observer
class OrderConfirmation extends Component {
  static errCaseHandling() {
    Toastr.showToastr({
      className: "nwc-toastr-list-danger nw-toastr",
      message: Checkout.CHECKOUT_MESSAGES.ORDER_CONFIRMATION.NO_ORDER_ID_FOUND,
      timeout: 3000,
    });
    window.location.href = "/";
  }

  constructor() {
    super();
    this.state = {
      orderId: "",
      loyaltyPointsData: null,
    };
    this.setloyaltyPointsData = this.setloyaltyPointsData.bind(this);
    this.addAnalytics = this.addAnalytics.bind(this);
    this.triggerGAForOrderConfirmation = this.triggerGAForOrderConfirmation.bind(
      this,
    );
  }

  componentDidMount() {
    if (!isAuthenticated()) {
      window.location.href = "/";
      return;
    }
    setPageType(pageType.orderConfirmation);
    Analytics.pageView(window.pageType);
    this.props.CheckoutStore.clearPresets();
    removePromoCode();
    Utils.localStorage.removeItem("paymentRequest");
    Utils.localStorage.removeItem("currentShippingAddress");
    Utils.localStorage.removeItem("paymentTypes");
    const { orderId, status } = this.props.match.params;
    if (orderId && status) {
      this.props.OrderConfirmationStore.getOrderConfirm(orderId).then(
        () => {
          this.setState({ orderId });
          this.addAnalytics();
        },
        () => {
          OrderConfirmation.errCaseHandling();
        },
      );
      setTimeout(() => {
        this.props.OrderConfirmationStore.getLoyaltyPointsData(orderId)
          .then(res => {
            this.setloyaltyPointsData(res);
          })
          .catch(err => {
            Toastr.showToastr({
              className: "nwc-toastr-list-danger nw-toastr",
              message: Loyalty.LOYALTY_BLOCK_MESSAGES.ERROR_MESSAGE,
              timeout: 3000,
            });
          });
      }, 1000);

    } else {
      OrderConfirmation.errCaseHandling();
    }
  }

  setloyaltyPointsData(res) {
    this.setState({
      loyaltyPointsData: res.data,
    });
  }

  addAnalytics() {
    console.log(toJS(this.props.OrderConfirmationStore));
    const {
      OrderConfirmationStore: {
        orderConfirmationData: {
          orderLevelDetails: { orderId },
          pricingDetails,
          productDetails,
        },
      },
    } = this.props;
    const { shipping, discounts, total, tax } = pricingDetails;
    const purchaseDetails = {
      order_id: orderId,
      total,
      revenue: total,
      shipping,
      tax,
      discount: discounts,
    };
    if (Utils.localStorage.getItem(`order_event_triggered_${orderId}`)) {
      return null;
    }
    Utils.localStorage.setItem(`order_event_triggered_${orderId}`, true);
    this.triggerGAForOrderConfirmation(orderId, pricingDetails, productDetails);
    this.triggerEvents(purchaseDetails, toJS(productDetails));
    return null;
  }

  // eslint-disable-next-line class-methods-use-this
  triggerGAForOrderConfirmation(orderId, pricingDetails, productDetails) {
    if (ga) {
      try {
        ga("require", "ecommerce");
        ga("ecommerce:addTransaction", {
          id: orderId,
          revenue: pricingDetails.total,
          shipping: pricingDetails.shipping,
        });

        productDetails.forEach(productData => {
          productData.products.forEach(product => {
            const categoryValue = `${product.category1}_${product.category2}_${
              product.category3
              }`;
            ga("ecommerce:addItem", {
              id: orderId,
              name: product.brand,
              sku: product.skuId,
              category: categoryValue,
              price: product.mrp,
              quantity: product.quantity,
            });
          });
        });
        ga("ecommerce:send");
      } catch (e) {
        console.log(e);
      }
    }
  }

  triggerEvents(purchaseDetails, purchaseProducts) {
    Analytics.trackEvent({
      action: Event.action.SUCCESSFUL_ORDER,
      label: this.state.orderId,
      category: Event.category.CHECKOUT,
    });
    if (purchaseProducts && purchaseDetails) {
      window.google_tag_params = {
        ecomm_pagetype: "purchase",
        ecomm_totalvalue: purchaseDetails.total,
        ecomm_prodid: purchaseProducts.map(product => product.sku),
      };
    }
    GTM.pushObject({
      purchaseDetails,
      products: purchaseProducts,
    });
    GTM.pushEvent(Event.GTMEvent.CONVERSION);
    GTM.pushEvent("orderconfirmation_trial");

    const utmMedium = readCookie("utm_medium");
    if (utmMedium) {
      GTM.pushObject({ source: utmMedium });
    }

    const orderPlaced = Utils.localStorage.getItem("orderPlaced");
    if (orderPlaced) {
      GTM.pushObject({ sendEcommerceEvent: true });
      Utils.localStorage.removeItem("orderPlaced");
    }

    let sephoraProducts = [];
    sephoraProducts = purchaseProducts[0].products.filter(
      product => SEPHORA_BRANDS.indexOf(product.brand.toLowerCase()) > -1,
    );
    if (sephoraProducts.length) {
      let sephoraTotal = 0;
      sephoraProducts.forEach(product => {
        sephoraTotal += product.sellingPrice;
      });
      GTM.pushWithEvent(
        { sephoraProducts, sephoraTotal },
        Event.GTMEvent.SEPHORA_CONVERSION,
      );
    }
  }

  render() {
    const {
      OrderConfirmationStore: { orderConfirmationData },
    } = this.props;
    const { loyaltyPointsData } = this.state;

    if (this.props.OrderConfirmationStore.isLoader) {
      return (
        <div className="nw-orderconfirm-loader">
          <Loader />
        </div>
      );
    }
    if (!orderConfirmationData) return null;
    return (
      <div className="nw-orderconfirm-wrapper">
        <OrderConfirmStaticDetails.component
          staticDetails={orderConfirmationData.orderLevelDetails}
          loyaltyPointsData={loyaltyPointsData}
        />
        <div className="nw-orderconfirm-details">
          <OrderSummaryBlock.component
            orderConfirmationData={orderConfirmationData}
            orderId={this.state.orderId}
          />
          <OrderConsignmentsBlock.component {...orderConfirmationData} />
        </div>
      </div>
    );
  }
}

OrderConfirmation.wrappedComponent.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({}).isRequired,
  }).isRequired,
  OrderConfirmationStore: PropTypes.shape({
    isLoader: PropTypes.bool.isRequired,
    getOrderConfirm: PropTypes.func.isRequired,
    getLoyaltyPointsData: PropTypes.func.isRequired,
    orderConfirmationData: PropTypes.object.isRequired,
  }).isRequired,
  CheckoutStore: PropTypes.shape({
    clearPresets: PropTypes.func.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("OrderConfirmationStore", "CheckoutStore", "AddressStore")(
    observer(component),
  );

const ProjectComponent = {
  getFinalComponent,
  wrapper: OrderConfirmation.wrappedComponent,
  component: OrderConfirmation,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/pages/OrderConfirmation/index.js